<template>
	<div class="starList">
		<star
		 :precent="precent||'0'"
		 @click.native="selectStarNum(index+1)"
		 :key="index"
		 v-for="(precent,index) in precentList"
		 :star-class-name="starColorClass"
		/>
		<div class="starNum" :class="starColorClass" v-if="!showText">{{starsNum}}</div>
		<div class="starNum" :class="starColorClass" v-else>{{{5:'惊喜',4:'满意',3:'一般',2:'失望',1:'极差'}[stars]}}</div>
	</div>
</template>

<script>
import Star from "@/components/Star";
export default {
	model: {
		prop: "stars",
		event: "updateStars"
	},
	props: {
		stars: {
			type: Number,
			default: 0,
			required: true
		},
		enabledClick: {
			type: Boolean,
			default: false
		},
		showText:{
			type: Boolean,
			default:false
		}
	},
	computed: {
		starsNum() {
			return this.stars.toFixed(1);
		},
		starColorClass(){
			let className = 'yellow';
			if(this.stars >=4){
				className = 'red';
			}else if(this.stars <3){
				className = 'gray';
			}
			return className
		},
		// 将总数转换成百分比的数组
		precentList() {
			let total = Math.floor(parseFloat(this.stars) * 100),
				// 整数
				num = Math.floor(total / 100),
				// 小数部分
				precent = total % 100,
				list = [];
			list = list.concat(("100,".repeat(num) + precent).split(","));
			list.length = 5;
			return list;
		}
	},
	methods: {
		selectStarNum(n) {
			if (this.enabledClick) {
				this.$emit("updateStars", n);
			}
		}
	},
	components: {
		Star
	}
};
</script>

<style lang="scss" scoped>
@import "~@/scss/libs.scss";
.starList {
	@include dis-flex(center);
	font-size: px2rem(20);
	line-height: 1;
	/deep/ .star {
		margin-right: px2rem(6);
	}
	.starNum {
		color: #a6a6a6;
		margin-left: px2rem(10);
		&.yellow{
			color: #f7cd0f;
		}
		&.red{
			color: #e32351;
		}
	}
}
</style>
